"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerReorderParticipantsOrderDirection = void 0;
var ProducerReorderParticipantsOrderDirection;
(function (ProducerReorderParticipantsOrderDirection) {
    ProducerReorderParticipantsOrderDirection["ascending"] = "ascending";
    ProducerReorderParticipantsOrderDirection["descending"] = "descending";
    ProducerReorderParticipantsOrderDirection["custom"] = "custom";
})(ProducerReorderParticipantsOrderDirection = exports.ProducerReorderParticipantsOrderDirection || (exports.ProducerReorderParticipantsOrderDirection = {}));
//# sourceMappingURL=producer-reorder-participants-reorder-directions.js.map